import React, { FunctionComponent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from "react-router-dom";
import { REPORTSTATUS } from '../util/DataModelInterface';

interface IActionButtonsProps {
  companyId: string,
  companyName: string,
  period: string,
  status: string,
  path: string,
  confirmButton: boolean
}

export const actionButtons = (companyId: string, companyName: string, period: string, status: string, path: string, confirmButton: boolean) => {
  return <ActionButtons companyId={companyId} companyName={companyName} period={period} status={status} path={path} confirmButton={confirmButton} />
}

export const ActionButtons: FunctionComponent<IActionButtonsProps> = (props) => {
  const navigate = useNavigate();
  const intl = useIntl();
  return (<>
    <button className="poc btn btn-secondary" title={intl.formatMessage({id: 'reports.openreport'})}
            onClick={ () => { navigate(props.path, { replace: false, state: { companyId: props.companyId, companyName: props.companyName, period: props.period, status: props.status, confirm: false }});}}>
      <i className="fa fa-eye me-2"></i>
      <span><FormattedMessage id={'reports.openreport'}/></span></button>
    {
    props.confirmButton && ( props.status === REPORTSTATUS.ONGOING || props.status === REPORTSTATUS.REOPENED) ?
      <button className="poc btn btn-primary" title={intl.formatMessage({id: 'reports.confirmreport'})}
            onClick={ () => { navigate(props.path, { replace: false, state: { companyId: props.companyId, companyName: props.companyName, period: props.period, status: props.status, confirm: true }}); }}>
      <i className="fa fa-check me-2"></i>
      <span><FormattedMessage id={'reports.confirmreport'}/></span></button> : <></>
    }</>
  );
};